import { useEffect } from "react";

// Injects a JSON-LD <script> into <head> on mount and removes it on unmount.
// `id` lets us avoid duplicating tags across navigations.
export default function JsonLd({ id, data }) {
  useEffect(() => {
    if (!data) return;
    const tag = document.createElement("script");
    tag.type = "application/ld+json";
    tag.id = id;
    tag.text = JSON.stringify(data);
    // Remove any prior tag with same id (e.g. SPA re-mount)
    const prev = document.getElementById(id);
    if (prev) prev.remove();
    document.head.appendChild(tag);
    return () => {
      const node = document.getElementById(id);
      if (node) node.remove();
    };
  }, [id, data]);

  return null;
}
